"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSourceType = void 0;
var SearchSourceType;
(function (SearchSourceType) {
    SearchSourceType["Blueprint"] = "blueprint";
    SearchSourceType["Command"] = "command";
})(SearchSourceType || (exports.SearchSourceType = SearchSourceType = {}));
